/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateAddRequest } from '../model/createAddRequest';
import { DomainAds } from '../model/domainAds';
import { ErrorResponse } from '../model/errorResponse';
import { UpdateAdRequest } from '../model/updateAdRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class AdsService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param domainId 
     * @param createAddRequest Ad content
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAd(domainId: string, createAddRequest: CreateAddRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createAd(domainId: string, createAddRequest: CreateAddRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createAd(domainId: string, createAddRequest: CreateAddRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createAd(domainId: string, createAddRequest: CreateAddRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling createAd.');
        }
        if (createAddRequest === null || createAddRequest === undefined) {
            throw new Error('Required parameter createAddRequest was null or undefined when calling createAd.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/ads`,
            createAddRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param domainId 
     * @param adId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAd(domainId: string, adId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteAd(domainId: string, adId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteAd(domainId: string, adId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteAd(domainId: string, adId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling deleteAd.');
        }
        if (adId === null || adId === undefined) {
            throw new Error('Required parameter adId was null or undefined when calling deleteAd.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/ads/${encodeURIComponent(String(adId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param domainId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDomainAds(domainId: string, observe?: 'body', reportProgress?: boolean): Observable<DomainAds>;
    public getDomainAds(domainId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DomainAds>>;
    public getDomainAds(domainId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DomainAds>>;
    public getDomainAds(domainId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling getDomainAds.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DomainAds>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/ads`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param domainId 
     * @param adId 
     * @param updateAdRequest Ad content
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAd(domainId: string, adId: string, updateAdRequest: UpdateAdRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateAd(domainId: string, adId: string, updateAdRequest: UpdateAdRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateAd(domainId: string, adId: string, updateAdRequest: UpdateAdRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateAd(domainId: string, adId: string, updateAdRequest: UpdateAdRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling updateAd.');
        }
        if (adId === null || adId === undefined) {
            throw new Error('Required parameter adId was null or undefined when calling updateAd.');
        }
        if (updateAdRequest === null || updateAdRequest === undefined) {
            throw new Error('Required parameter updateAdRequest was null or undefined when calling updateAd.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/ads/${encodeURIComponent(String(adId))}`,
            updateAdRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
